import React from 'react';

import AuthLayout from '~components/login/AuthLayout/AuthLayout';

import AuthFrame from '~assets/images/auth/auth_frame.png';

import styles from './AuthLayout.module.scss';

interface AuthLayoutWithFrameProps {
	children: React.ReactNode;
}

const AuthLayoutWithFrame: React.FC<AuthLayoutWithFrameProps> = ({ children }) => {
	return (
		<AuthLayout>
			<div className={styles.authWithFrameContainer}>
				{children}
				<div className={styles.authFrame}>
					<img src={AuthFrame} />
				</div>
			</div>
		</AuthLayout>
	);
};

export default AuthLayoutWithFrame;
